interface IFirebase {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  storageBucket: string;
}

interface IInstitution {
  unlimitedCredits: boolean;
  emailPattern: string;
  template: string;
  title: string;
  key: string;
}

declare const __GOOGLE_API_KEY__: string;
declare const __API__: string;
declare const __WS__: string;
declare const __TERMS_URL__: string;
declare const __GOOGLE_CLIENT_ID__: string;
declare const __FB_APP_ID__: string;
declare const __RECAPTCHA_KEY__: string;
declare const __DASHBOARD_URL__: string;
declare const __FIREBASE__: IFirebase;
declare const __MIXPANEL_TOKEN__: string;
declare const __INSTITUTION__: IInstitution | null;
declare const __CURRENT_STAGE__: any;
declare const __USER_EMAIL__: string;
declare const __PEER_NAME__: string;
declare const __GDPR_ENABLED__: boolean;

export const USER_ID = (window as any).__USERID__;
export const COMPANY_ID = (window as any).__COMPANYID__;
export const REF_CODE = (window as any).__REF_CODE__;
export const PROMO_CODE = (window as any).__PROMO_CODE__;
export const LANDED = (window as any).__LANDED__;
export const CURRENT_STAGE = (window as any).__CURRENT_STAGE__ || __CURRENT_STAGE__;
export const INSTITUTION = (window as any).__INSTITUTION__ || __INSTITUTION__;

export const TERMS_URL = (window as any).__TERMS_URL__ || __TERMS_URL__;
export const DASHBOARD_URL = (window as any).__DASHBOARD_URL__ || __DASHBOARD_URL__;

export const WS = (window as any).__WS__ || __WS__;
export const API = (window as any).__API__ || __API__;

export const FIREBASE = (window as any).__FIREBASE__ || __FIREBASE__;
export const GOOGLE_API_KEY = (window as any).__GOOGLE_API_KEY__ || __GOOGLE_API_KEY__;
export const GOOGLE_CLIENT_ID = (window as any).__GOOGLE_CLIENT_ID__ || __GOOGLE_CLIENT_ID__;
export const RECAPTCHA_KEY = (window as any).__RECAPTCHA_KEY__ || __RECAPTCHA_KEY__;
export const FB_APP_ID = (window as any).__FB_APP_ID__ || __FB_APP_ID__;

export const MIXPANEL_TOKEN = (window as any).__MIXPANEL_TOKEN__ || __MIXPANEL_TOKEN__;

export const IS_SESSION_COMPLETE = (window as any).__IS_SESSION_COMPLETE__ || false;
export const USER_EMAIL = (window as any).__USER_EMAIL__ || __USER_EMAIL__;
export const PEER_NAME = (window as any).__PEER_NAME__ || __PEER_NAME__;

export const GDPR_ENABLED = (window as any).__GDPR_ENABLED__ || __GDPR_ENABLED__ || false;
export const WHITE_LABEL =  (window as any).__WHITE_LABEL__ || false;
export const WHITE_LABEL_EMAIL_VERIFIED =  (window as any).__WHITE_LABEL_EMAIL_VERIFIED__;
export const WHITE_LABEL_ID =  (window as any).__WHITE_LABEL_ID__;

export const TUTORIAL = (window as any).__TUTORIAL__;
